import React, { useState } from "react";
import AuthLayout from "components/Layout/AuthLayout";
import { AuthCard } from "components/Card/AuthCard";
import { lang } from "constant/lang";
import { useForm } from "react-hook-form";
import actionApi from "services/actionApi";
import makeToast from "utils/toast/makeToast";
import Button from "components/Button/Button";
import Input from "components/Form/Input";
import { useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    watch,
    formState: { errors, isDirty, isValid },
    handleSubmit,
  } = useForm();
  const disabled =
    isSubmitting || !isDirty || !isValid || Object.keys(errors).length > 0;

  const onSubmit = async (payload) => {
    setIsSubmitting(true);
    actionApi
      .forgotPassword({ email: payload?.email })
      .then((response) => {
        setIsDone(true);
      })
      .catch((err) => {
        makeToast({ label: err?.response?.data?.errors?.[0], type: "error" });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <AuthLayout>
      <AuthCard className="justify-center">
        <span className="text-2xl text-wce-navy font-medium mb-6 self-center">
          Forgot Password
        </span>
        <span className="text-sm text-wce-neutral-9 mb-6">
          {!isDone
            ? lang.auth.forgotPassword.body.input
            : lang.auth.forgotPassword.body.sent}
        </span>
        {!isDone ? (
          <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
            <Input
              {...register("email", { required: true })}
              className="mb-4"
              type="email"
              placeholder="Email"
              errors={errors}
            />
            <Button
              type="submit"
              size="large"
              className="w-full mb-6 h-10"
              rounded
              disabled={disabled}
            >
              Send Email
            </Button>
          </form>
        ) : (
          <Button
            size="large"
            className="w-full mb-6 h-10"
            rounded
            onClick={() => navigate("/login")}
          >
            Go to Login Page
          </Button>
        )}
      </AuthCard>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
